// src/BlogGuides.js
import React, { useContext, useEffect } from 'react';
import { Link } from "react-router-dom";
import guides from "./GuidesFiles";
import { LanguageContext } from './LanguageContext';
import "./css/BlogGuides.css";

export default function BlogGuides() {
  const { language, translations } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Group guides by category
  const groupedGuides = guides.reduce((acc, guide) => {
    const category = guide.category || "Other";
    if (!acc[category]) acc[category] = [];
    acc[category].push(guide);
    return acc;
  }, {});

  return (
    <div className="blog-guides-page">
      <div className="blog-guides-list">
        <h1 className="guides-title">
          {language === "pt" ? (
            <>Guias de <span>Ajuda</span></>
          ) : (
            <>Help <span>Guides</span></>
          )}
        </h1>

        {Object.entries(groupedGuides).map(([category, items]) => (
          <div key={category} className="guide-category">
            <h2 className="category-title">{translations[`categories.${category}`] || category}</h2>
            <ul>
              {items.map((g) => (
                <li key={g.id}
                  style={{
                    backgroundImage: `url(${g.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                  >
                  <Link to={`/blog-guides/${g.id}`}>
                    {typeof g.title === "object"
                      ? (g.title[language] || g.title.en)
                      : g.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

      </div>
    </div>
  );
}
